<template>
    <div>
      <div class="page-header">
        <div class="container-fluid d-flex justify-content-between">
          <h3 style="height:33px">My Tasks / Inspections</h3>
          <b-button v-if="this.selectedStatus !== null" @click="selectedStatus = null"><i class="fas fa-caret-left mr-2"></i>Back</b-button>
        </div>
      </div>
      <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
        <!-- Overdue Tasks -->
        <div>
          <div v-if="filteredProperties.length" class="mb-4">
            <b-form-select v-model="selectedPropertyId" :options="filteredProperties" text-field="name" value-field="id" @change="onSelectProperty">
              <!-- This slot appears above the options from 'options' prop -->
              <template #first>
                <b-form-select-option :value="null">-- All properties with Tasks --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <div v-if="!this.tasksOverDue.length && !this.taskDueThisWeek.length && !this.taskCompleted.length && !this.loading" class="alert alert-primary">You currently have no overdue, pending or completed tasks to view.</div>
          <h5 v-if="false" class="my-1 text-danger"><strong>({{this.tasksOverDue.length}}) Overdue</strong></h5>
          <div v-if="selectedStatus === null || selectedStatus === 'overdue'" @click="onSelectStatus('overdue')" class="py-3 pointer alert alert-danger d-flex justify-content-between align-items-center">
            <strong>({{this.tasksOverDue.length}}) Overdue</strong>
            <i v-if="selectedStatus === null" class="fas fa-chevron-right"></i>
          </div>
          <!--Table-->
          <div v-if="this.tasksOverDue.length > 0 && this.selectedStatus === 'overdue'">
            <b-table-simple bordered class="rg-table mb-5">
              <b-thead>
                <b-tr>
                  <b-th>Name</b-th>
                  <b-th>Location(s)</b-th>
                  <b-th>Due Date</b-th>
                  <b-th>Status</b-th>
                  <b-th class="text-center">Actions</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="task in this.tasksOverDue" v-bind:key="task.resultId">
                  <b-td class="emphasis">
                    <div>{{ task.name }}</div>
                  </b-td>
                  <b-td>
                    <span >
                      {{task.location}}
                    </span>
                  </b-td>
                  <b-td>
                    <div>{{ task.dueDateLocal | formatDateWithDayName }}</div>
                  </b-td>
                  <b-td>
                    <div>{{ task.status | splitOnUpperCase }}</div>
                  </b-td>
                  <b-td class="table-action text-center">
                    <router-link title="Perform Task" :to="{ name: 'ExecuteRoutineTask', params: { resultId: task.resultId, instanceId: task.instanceId }}" class="btn btn-link"><i class="fas fa-edit"></i></router-link>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
        <!-- Due this week Tasks -->
        <div>
          <h5 v-if="false" class="my-1 text-info"><strong>({{this.taskDueThisWeek.length}}) Due this week</strong></h5>
          <div v-if="selectedStatus === null || selectedStatus === 'dueThisWeek'" @click="onSelectStatus('dueThisWeek')" class="py-3 pointer alert alert-info d-flex justify-content-between align-items-center">
            <strong>({{this.taskDueThisWeek.length}}) Due this week</strong>
            <i v-if="selectedStatus === null" class="fas fa-chevron-right"></i>
          </div>
          <!--Table-->
          <div v-if="this.taskDueThisWeek.length > 0  && this.selectedStatus === 'dueThisWeek'">
            <b-table-simple bordered class="rg-table mb-5">
              <b-thead>
                <b-tr>
                  <b-th>Name</b-th>
                  <b-th>Location(s)</b-th>
                  <b-th>Due Date</b-th>
                  <b-th>Status</b-th>
                  <b-th class="text-center">Actions</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="task in this.taskDueThisWeek" v-bind:key="task.resultId">
                  <b-td class="emphasis">
                    <div>{{ task.name }}</div>
                  </b-td>
                  <b-td>
                    <span >
                      {{task.location}}
                    </span>
                  </b-td>
                  <b-td>
                    <div>{{ task.dueDateLocal | formatDateWithDayName }}</div>
                  </b-td>
                  <b-td>
                    <div>{{ task.status | splitOnUpperCase }}</div>
                  </b-td>
                  <b-td class="table-action text-center">
                    <router-link title="Perform Task" :to="{ name: 'ExecuteRoutineTask', params: { resultId: task.resultId, instanceId: task.instanceId }}" class="btn btn-link"><i class="fas fa-edit"></i></router-link>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
        <!-- Completed Tasks -->
        <div>
          <h5 v-if="false" class="my-1 text-success"><strong>({{this.taskCompleted.length}}) Completed</strong></h5>
          <div v-if="selectedStatus === null || selectedStatus === 'completed'" @click="onSelectStatus('completed')" class="py-3 pointer alert alert-success d-flex justify-content-between align-items-center">
            <strong>({{this.taskCompleted.length}}) Completed</strong>
            <i v-if="selectedStatus === null" class="fas fa-chevron-right"></i>
          </div>
          <!--Table-->
          <div v-if="this.taskCompleted.length > 0  && this.selectedStatus === 'completed'">
            <b-table-simple bordered class="rg-table mb-5">
              <b-thead>
                <b-tr>
                  <b-th>Name</b-th>
                  <b-th>Location(s)</b-th>
                  <b-th>Due Date</b-th>
                  <b-th>Completed Date</b-th>
                  <b-th>Status</b-th>
                  <b-th class="text-center">Actions</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="task in this.taskCompleted" v-bind:key="task.resultId">
                  <b-td class="emphasis">
                    <div>{{ task.name }}</div>
                  </b-td>
                  <b-td>
                    <span >
                      {{task.location}}
                    </span>
                  </b-td>
                  <b-td>
                    <div>{{ task.dueDateLocal | formatDateWithDayName }}</div>
                  </b-td>
                  <b-td>
                    <div>{{task.dateLastUpdatedOrCompleted | formatDateWithDayName}}</div>
                  </b-td>
                  <b-td>
                    <div>{{ task.status| splitOnUpperCase }}</div>
                  </b-td>
                  <b-td class="table-action text-center">
                    <router-link title="Perform Task" :to="{ name: 'ExecuteRoutineTask', params: { resultId: task.resultId, instanceId: task.instanceId }}" class="btn btn-link"><i class="fas fa-edit"></i></router-link>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { spr2Procedures, spr2Validation } from '../mixins/Spr2SharedFunctions'
import 'vue-datetime/dist/vue-datetime.css'
import RoutineTaskInstances from './RoutineTaskInstances.vue'
import moment from 'moment'

export default {
  name: 'Resources',
  mixins: [ spr2Procedures, spr2Validation ],
  components: {RoutineTaskInstances},
  data () {
    return {
      loading: false,
      myRoutineTasks: [],
      endOfDay: moment().endOf('day').format('MM-DD-YYYY hh:mm'),
      startOfWeek: moment().startOf('isoWeek').format('MM-DD-YYYY hh:mm'),
      endOfWeek: moment().endOf('isoWeek').format('MM-DD-YYYY hh:mm'),
      properties: [],
      selectedPropertyId: null,
      uniqueTaskPropertyIds: [],
      selectedStatus: null
    }
  },
  async created () {
    this.loading = true
    await this.doLoadMyRoutineTasks()
    await this.getLoggedInUserProperties()
      .then((result) => {
        console.log('setting event user properties for My Tasks: ' + JSON.stringify(result.data.properties, null, 2))
        this.properties = result.data.properties
        if (this.properties.length > 0) {
          this.onSelectProperty(this.selectedPropertyId)
        }
      })
    this.loading = false
    console.log('EOD', this.endOfDay)
    console.log('SOW', this.startOfWeek)
    console.log('EOW', this.endOfWeek)
  },
  methods: {
    ...mapActions('routineTasks', ['getRoutineTasks', 'saveRoutineTask', 'getMyRoutineTasks']),
    ...mapActions('events', ['getLoggedInUserProperties']),
    async doLoadMyRoutineTasks () {
      this.isBusy = true
      this.getMyRoutineTasks().then((r) => {
        this.myRoutineTasks = r.instances
        this.uniqueTaskPropertyIds = r.instances.map(t => t.propertyId)
        this.isBusy = false
        console.log('RTPID', this.uniqueTaskPropertyIds)
      })
    },
    async onSelectProperty (propertyId) {
      // this.loading = true
      // console.log('PROPERTY SELECTED')
      // this.loading = false
    },
    async onSelectStatus (status) {
      this.selectedStatus = status
    }
  },
  computed: {
    filteredProperties () {
      let properties = this.properties.filter((property) => {
        return this.uniqueTaskPropertyIds.includes(property.id)
      })
      return properties
    },
    filteredTasks () {
      let tasks = this.myRoutineTasks.filter((task) => {
        if (this.selectedPropertyId !== null) {
          return task.propertyId === this.selectedPropertyId
        } else {
          return true
        }
      })
      return tasks
    },
    tasksOverDue () {
      let tasks = this.filteredTasks.filter((task) => {
        let dueDate = moment(task.dueDateLocal, 'YYYY-MM-DD').endOf('day')
        return dueDate.isBefore(this.endOfDay) && task.status.toLowerCase() !== 'complete'
      })
      return tasks
    },
    taskDueThisWeek () {
      let tasks = this.filteredTasks.filter((task) => {
        let dueDate = moment(task.dueDateLocal, 'YYYY-MM-DD').endOf('day')
        return dueDate.isAfter(this.startOfWeek) && dueDate.isBefore(this.endOfWeek) && task.status.toLowerCase() !== 'complete'
      })
      return tasks
    },
    // taskDueLaterThanThisWeek () {
    //   let tasks = this.filteredTasks.filter((task) => {
    //     let dueDate = moment(task.dueDateLocal, 'YYYY-MM-DD').endOf('day')
    //     return dueDate.isAfter(this.endOfWeek)
    //   })
    //   return tasks
    // },
    taskCompleted () {
      let tasks = this.filteredTasks.filter((task) => {
        let dueDate = moment(task.dueDateLocal, 'YYYY-MM-DD').endOf('day')
        let completedDate = task.dateLastUpdatedOrCompleted === null ? moment() : moment(task.dateLastUpdatedOrCompleted, 'YYYY-MM-DD')
        let oneWeekBack = moment().startOf('day').add(-7, 'days')
        return task.status.toLowerCase() === 'complete' && (dueDate.isAfter(oneWeekBack) || completedDate.isAfter(oneWeekBack))
      })
      return tasks
    }
  },
  filters: {
    splitOnUpperCase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.match(/[A-Z][a-z]+|[0-9]+/g).join(' ')
    }
  }
}
</script>
<style>
.dropdown-content{
    position: fixed;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/MyRoutineTasks.vue